import React from 'react';
import { Loader } from 'ui';

function PaddedLoader() {
  return (
    <div className="flex justify-center p-4">
      <Loader size="huge" />
    </div>
  );
}

export default PaddedLoader;
